// cleaned MainContactForm.js
import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import Button from "@material-ui/core/Button";
import { api_path } from "../../shared.js";
import TagBox from "devextreme-react/tag-box";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import { Box, Typography, Grid } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import StageFlow from "./StageFlow";
const defaultBU = {
  SEA: false,
  AIR: false,
  FOOD: false,
  TIRE: false,
  REEFER: false,
  TANK: false,
  SOC: false,
  WORLDWIDE: false,
  LCL: false,
  WH: false,
  OTHER: false,
};
const buList = [
  "SEA",
  "AIR",
  "FOOD",
  "TIRE",
  "REEFER",
  "TANK",
  "SOC",
  "WORLDWIDE",
  "LCL",
  "WH",
  "OTHER",
];

const MainContactForm = ({
  CUSTOMER_CODE,
  SALES_ID,
  SALES_NAME,
  onCheckDuplicate,
  onCheckDuplicateTax,
  isDuplicate,
  isDuplicateTax,
  onSend,
}) => {
  const navigate = useNavigate();
  const token = process.env.REACT_APP_API_TOKEN;
  const getCrmID = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const getUserEMail = JSON.parse(localStorage.getItem("USER_EMAIL"));
  const getEmpCode = JSON.parse(localStorage.getItem("USER_EMPCODE"));
  const formatDateTime = (dateTime) => {
    if (!dateTime) return "N/A";

    const date = new Date(dateTime);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // เดือน 0-11
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year}`;
  };
  const filterOptions = createFilterOptions({
    ignoreCase: true,
    matchFrom: "any",
    limit: 500,
    stringify: (option: FilmOptionType) => option.label,
  });
  const STYLES = {
    "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot":
    {
      padding: "3px !important",
      fontSize: "14px",
      color: "#000000",
    },
    "&.MuiAutocomplete-root": {
      padding: "0px",
    },
  };
  const [form, setForm] = useState({
    CUSTOMER_CODE: "",
    SMF_CUSCODE: "",
    CUSTOMER_NAME: "",
    TAX_ID: "",
    CONTACT_NAME: "",
    CUSTOMER_EMAIL: "",
    CUSTOMER_PHONE: "",
    CUSTOMER_ADDRESS: "",
    CUSTOMER_PROVINCE: "",
    CUSTOMER_WEBSITE: "",
    NOTE: "",
    DATASOURCE: "",
  });
  const [GET_HAS_FOLLOW_UP, SET_HAS_FOLLOW_UP] = useState();
  const [GET_LAST_FOLLOW_UP, SET_LAST_FOLLOW_UP] = useState();
  const [GET_HAS_SALES_VISIT, SET_HAS_SALES_VISIT] = useState();
  const [GET_LAST_SALES_VISIT, SET_LAST_SALES_VISIT] = useState();
  const [getShipper, setShipper] = useState([]);
  const [getShipperList, setShipperList] = useState([]);

  const [getConsignee, setConsignee] = useState([]);
  const [getConsigneeList, setConsigneeList] = useState([]);

  const [getAgent, setAgent] = useState([]);
  const [getAgentList, setAgentList] = useState([]);

  const [getShipperLoad, setShipperLoad] = useState([]);
  const [getShipperLoadList, setShipperLoadList] = useState([]);

  const [getCoload, setCoload] = useState([]);
  const [getColoadList, setColoadList] = useState([]);

  const [getSalesList, setSalesList] = useState([]);
  const [getSelectedSales, setSelectedSales] = useState([]);
  const [getSales, setSales] = useState([]);
  const [getTierList, setTierList] = useState([]);
  const [getSelectedTier, setSelectedTier] = useState([]);
  const [getTier, setTier] = useState([]);

  const [getTypeList, setTypeList] = useState([]);
  const [getSelectedType, setSelectedType] = useState([]);
  const [getType, setType] = useState([]);

  const [getCloseReasonList, setCloseReasonList] = useState([]);
  const [getSelectedCloseReason, setSelectedCloseReason] = useState([]);
  const [getCloseReason, setCloseReason] = useState([]);
  const [getRemark, setRemark] = useState("");
  const [provinceList, setProvinceList] = useState([]);
  const [getSelectedProvince, setSelectedProvince] = useState([]);
  const [getProvince, setProvince] = useState([]);
  const [getStageList, setStageList] = useState([]);
  const [getSelectStage, setSelectedStage] = useState([]);
  const [getStage, setStage] = useState([]);

  const [bu, setBU] = useState(defaultBU);
  const [getCampaignList, setCampaignList] = useState([]);
  const [getSelectCampaign, setSelectedCampaign] = useState([]);
  const [getCampaign, setCampaign] = useState([]);

  const [getDecisionMaker, setDecisionMaker] = useState(null);
  const [selectedDecisionMaker, setSelectedDecisionMaker] = useState([]);
  const [getDecisionMakerList, setDecisionMakerList] = useState([]);
  const fetchOptions = async () => {
    try {
      const [tierRes, typeRes, stageRes, salesRes, reasonRes, CampaignRes] =
        await Promise.all([
          axios.get(`${api_path}/MS_CUSTOMER_MASTER.php?type=CUSTOMER_TIER`),
          axios.get(`${api_path}/MS_CUSTOMER_MASTER.php?type=CUSTOMER_TYPE`),
          axios.get(`${api_path}/MS_CUSTOMER_MASTER.php?type=CUSTOMER_STAGE`),
          axios.get(
            `${api_path}/GET_SALES.php?role=` +
            getUserRole +
            `&empcode=yes&user=` +
            getCrmID
          ),
          axios.get(`${api_path}/MS_CUSTOMER_MASTER.php?type=LOST_REASON`),
          axios.get(`${api_path}/customer/get-campaign.php`),
        ]);
      setTierList(tierRes.data);
      setTypeList(typeRes.data);
      setStageList(stageRes.data);
      setSalesList(salesRes.data);
      setCloseReasonList(reasonRes.data);
      setCampaignList(CampaignRes.data);
      // ✅ ตั้งค่า default customer_stage
      if (stageRes.data && stageRes.data.length > 0) {
        // ตัวอย่าง: เอาค่าแรกเป็น default
        const defaultStage = stageRes.data[1];
        setStage({
          value: defaultStage.value,
          label: defaultStage.label,
        });

        setSelectedStage(2);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const fetchOptions2 = () => {
    axios
      .get(api_path + `/customer/get-customer-crm.php`)
      .then((response) => {
        setDecisionMakerList(response.data);
        setShipperList(response.data);
        setConsigneeList(response.data);
        setShipperLoadList(response.data);
        setColoadList(response.data);
        setAgentList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleBUChange = (e) => {
    const { name, checked } = e.target;
    setBU((prev) => ({ ...prev, [name]: checked }));
  };
  const fetchCustomer = async (id, SALES_ID) => {
    try {
      const res = await fetch(
        `${api_path}/customer/customers.php?id=${id}&userId=${getEmpCode}&crmId=${getCrmID}&roleId=${getUserRole}&salesId=${SALES_ID}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      const i = data[0];

      onSend(i.SMF_CUSCODE);
      SET_HAS_SALES_VISIT(i.HAS_SALES_VISIT);
      SET_LAST_SALES_VISIT(i.LAST_SALES_VISIT);
      SET_HAS_FOLLOW_UP(i.HAS_FOLLOW_UP);
      SET_LAST_FOLLOW_UP(i.HAS_FOLLOW_UP);
      setForm({
        CUSTOMER_CODE: i.CRM_CUSCODE,
        SMF_CUSCODE: i.SMF_CUSCODE,
        CUSTOMER_NAME: i.CUSTOMER_NAME,
        CONTACT_NAME: i.CONTACT_NAME,
        CUSTOMER_ADDRESS: i.CUSTOMER_ADDRESS,
        CUSTOMER_PHONE: i.CUSTOMER_PHONE,
        CUSTOMER_EMAIL: i.CUSTOMER_EMAIL,
        TAX_ID: i.TAX_ID,
        CUSTOMER_PROVINCE: i.CUSTOMER_PROVINCE,
        CUSTOMER_WEBSITE: i.CUSTOMER_WEBSITE,
        NOTE: i.NOTE1

      });
      setSelectedProvince(i.CUSTOMER_PROVINCE);
      setProvince({
        value: i.CUSTOMER_PROVINCE,
        label: i.CUSTOMER_PROVINCE,
      });
      setSelectedType(i.CUSTOMER_TYPE);
      setType({
        value: i.CUSTOMER_TYPE,
        label: i.CUSTOMER_TYPE_EN,
      });
      setSelectedTier(i.CUSTOMER_TIER);
      setTier({
        value: i.CUSTOMER_TIER,
        label: i.GLOBAL_TIER_EN,
      });
      setSelectedStage(i.CUSTOMER_STATUS);
      setStage({
        value: i.CUSTOMER_STATUS,
        label: i.CUSTOMER_STATUS_EN,
      });
      setSelectedCloseReason(i.CLOSE_STATUS);
      setCloseReason({
        value: i.CLOSE_STATUS,
        label: i.CLOSE_STATUS_EN,
      });
      setRemark(i.CLOSE_REMARK);
      setDecisionMaker(i.DECISION_MAKER);
      // setSelectedDecisionMaker(i.DECISION_MAKER);
      // setDecisionMaker({
      //   DECISION_NAME: i.DECISION_MAKER,
      //   DECISION_NAME: i.DECISION_MAKER,
      // });

      if (i.CUSTOMER_BU) {
        const selectedArray2 = i.CUSTOMER_BU.split(",").map((id) => id.trim()); // trim กัน space
        setSelectedBUTag(selectedArray2);
      }
      if (i.ACTIVE_STATUS !== undefined && i.ACTIVE_STATUS !== null) {
        const label = i.ACTIVE_STATUS == 1 ? "Active" : "Inactive";

        setSelectedStatus(i.ACTIVE_STATUS);
        setStatus({
          value: i.ACTIVE_STATUS,
          label: label,
        });
      }
      if (i.CAMPAIGN_ID) {
        setSelectedCampaign(i.CAMPAIGN_ID);
        setCampaign({
          value: i.CAMPAIGN_ID,
          label: i.CAMPAIGN_NAME,
        });
      }
      if (i.CUSTOMER_TERM) {
        setSelectIncoterm(i.CUSTOMER_TERM);
        setIncoterm({
          value: i.CUSTOMER_TERM,
          label: i.CUSTOMER_TERM,
        });
      }
      if (i.SHIPPER_CODE) {
        setShipper(i.SHIPPER_CODE);
      }
      if (i.CNEE_CODE) {
        setConsignee(i.CNEE_CODE);
      }
      if (i.AGENT_CODE) {
        setAgent(i.CNEE_CODE);
      }
      if (i.SHIPPERLOAD_CODE) {
        setShipperLoad(i.SHIPPERLOAD_CODE);
      }

      if (i.COLOAD_CODE) {
        setCoload(i.COLOAD_CODE);
      }
    } catch (error) {
      console.error("Failed to fetch customer:", error);
    }
  };

  useEffect(() => {
    fetchOptions();
    fetchOptions2();
    fetchProvince();
    if (CUSTOMER_CODE) {
      fetchCustomer(CUSTOMER_CODE, SALES_ID);
    }
    //            if (getUserRole == 1) {
    //   if (SALES_ID && SALES_NAME) {
    //     // ใช้ค่าจาก props/API
    //     setSelectedSales(SALES_ID);
    //     setSales({
    //       SALE_CODE: SALES_ID,
    //       SALE_NAME: SALES_NAME,
    //     });
    //     fetchCustomer(CUSTOMER_CODE, SALES_ID);
    //   } else if (getEmpCode && getUserEMail) {
    //     // fallback จาก localStorage
    //     setSelectedSales(getEmpCode);
    //     setSales({
    //       SALE_CODE: getEmpCode,
    //       SALE_NAME: getUserEMail,
    //     });
    //   }
    // } else {
    //   setSelectedSales(i.FIRST_SALES_ID);
    //   setSales({
    //     SALE_CODE: i.FIRST_SALES_ID,
    //     SALE_NAME: getUserEMail,
    //   });
    // }
    if (getUserRole == 1) {
      setSelectedSales(getEmpCode ?? "");
      setSales({
        SALE_CODE: getEmpCode ?? "",
        SALE_NAME: getUserEMail ?? "",
      });
    } else {
      // ✅ ใช้ชื่อ props ให้ตรงกับที่ parent ส่งมา
      setSelectedSales(SALES_ID ?? "");
      setSales({
        SALE_CODE: SALES_ID ?? "",
        SALE_NAME: SALES_NAME ?? "",
      });
    }
  }, [CUSTOMER_CODE, SALES_ID]);

  //useEffect(() => {
  // console.log("📢 SALES_ID ที่รับมา:", SALES_ID);
  // console.log("📢 SALES_NAME ที่รับมา:", SALES_NAME);
  // console.log("📢 Fallback EmpCode:", getEmpCode);
  // console.log("📢 Fallback Email:", getUserEMail);
  // if (CUSTOMER_CODE) {
  //   if (SALES_ID) {
  //     fetchCustomer(CUSTOMER_CODE, SALES_ID);
  //   } else {
  //     fetchCustomer(CUSTOMER_CODE, getEmpCode);
  //   }
  // }
  // }, [SALES_ID, SALES_NAME]);
  // useEffect จะทำงานทุกครั้งที่ props SALES_ID / SALES_NAME เปลี่ยน
  // useEffect(() => {
  //   setSelectedSales({
  //     SALE_CODE: SALES_ID ?? "",
  //     SALE_NAME: SALES_NAME ?? "",
  //   });
  // }, [SALES_ID, SALES_NAME]);
  // const handleSalesChange = (saleCode, saleName) => {
  //   setSelectedSales({ SALE_CODE: saleCode, SALE_NAME: saleName });
  //   if (onSend) {
  //     onSend({ SALE_CODE: saleCode, SALE_NAME: saleName });
  //   }
  // };

  const handleSalesChange = (obj) => {
    setSelectedSales(obj.SALE_CODE);
    setSales({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
  };
  useEffect(() => {
    if (getSelectCampaign) {
      console.log("✅ Campaign selected:", getSelectCampaign, getCampaign);
    }
  }, [getSelectCampaign, getCampaign]);
  const fetchProvince = () => {
    axios
      .get(api_path + `/MS_PROVINCE.php`)
      .then((response) => {
        setProvinceList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // useEffect(() => {
  //   const getCampaignDropdown = async () => {
  //     try {
  //       const resstate = await fetch(api_path + `/customer/campaigns.php?getid=1`, {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`, // ใส่ token ตรงนี้
  //         },
  //       });

  //       if (!resstate.ok) {
  //         throw new Error("Network response was not ok");
  //       }

  //       const getst = await resstate.json();
  //       setCampaignList(getst);
  //     } catch (error) {
  //       console.error("Fetch campaign error:", error);
  //     }
  //   };

  //   getCampaignDropdown();
  // }, []);

  const handleCampaignChange = (obj) => {
    setCampaign({ value: obj.value, label: obj.label });
    setSelectedCampaign(obj.value);
  };
  const handleProvinceChange = (obj) => {
    setProvince({ value: obj.value, label: obj.label });
    setSelectedProvince(obj.value);
  };
  const handleTypeChange = (obj) => {
    setType({ value: obj.value, label: obj.label });
    setSelectedType(obj.value);
  };
  const handleCloseChange = (obj) => {
    setCloseReason({ value: obj.value, label: obj.label });
    setSelectedCloseReason(obj.value);
  };
  // เงื่อนไข disable ปุ่ม
  const isCustomerEmpty = !form.SMF_CUSCODE;
  const isQuotationStage = getSelectStage == 6;
  const isSaveDisabled = (isCustomerEmpty && isQuotationStage) || isDuplicate;
  // const isSaveDisabled = form.SMF_CUSCODE === "" && getSelectStage == 6;
  const handleStageChange = (obj) => {
    setStage({ value: obj.value, label: obj.label });
    setSelectedStage(obj.value);
    if (obj.value == 6) {
      //won
      if (form.SMF_CUSCODE === "") {
        swal({
          title: "Sorry...",
          text: "Please update SMF Code.",
          icon: "warning",
        });
      }
    } else if (obj.value == 7) {
      //lost
    }
  };
  const [previousStage, setPreviousStage] = useState(null); // ✅ เพิ่ม state นี้ไว้จำค่า stage เดิม
  const handleStatusChange = (obj) => {
    // เก็บ stage เดิมไว้ก่อนเปลี่ยน
    setPreviousStage(getStage);
    setStatus({ value: obj.value, label: obj.label });
    setSelectedStatus(obj.value);
    if (obj.value == "0") {
      setStage({ value: 7, label: "Close-Lost" });
      setSelectedStage(7);
    } else {
      // ถ้ามี stage เดิมที่เคยเก็บไว้ ให้ revert กลับ
      if (previousStage) {
        setStage(previousStage);
        setSelectedStage(previousStage.value);
        setPreviousStage(null); // เคลียร์ค่าเก็บไว้
      }
    }
    // if (obj.value == 6) {
    //   //won
    //   if (form.SMF_CUSCODE === "") {
    //     swal({
    //       title: "Sorry...",
    //       text: "Please update SMF Code.",
    //       icon: "warning",
    //     });
    //   }
    // } else if (obj.value == 7) {
    //   //lost
    // }
  };
  const handleTierChange = (obj) => {
    setSelectedTier(obj.value);
    setTier({
      value: obj.value,
      label: obj.label,
    });
  };

  // const handleDecisionMakerChange = (obj) => {
  //   setSelectedDecisionMaker(obj.DECISION_NAME);
  //   setDecisionMaker({
  //     DECISION_NAME: obj.DECISION_NAME,
  //     DECISION_NAME: obj.DECISION_NAME,
  //   });
  // };
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({
    taxId: "",
    stage: "",
    stageClose: "",
    stageCloseReason: "",
    status: "",
    type: "",
    tier: "",
  });

  const validate = () => {
    let newErrors = {
      taxId: "",
      stage: "",
      stageClose: "",
      stageCloseReason: "",
      status: "",
      type: "",
      tier: "",
    };

    if (!form.TAX_ID) {
      newErrors.taxId = "Please enter Tax Identification Number";
      // } else if (!/^[0-9]{13}$/.test(form.TAX_ID)) {
      //   newErrors.taxId = "Tax Identification Number must be 13 digits";
    }

    if (!getSelectStage || getSelectStage.length === 0 || getSelectStage == 0) {
      newErrors.stage = "Please select customer stage";
    }
    if (
      !getSelectedType ||
      getSelectedType.length === 0 ||
      getSelectedType == 0
    ) {
      newErrors.type = "Please select customer type";
    }
    if (
      !getSelectedTier ||
      getSelectedTier.length === 0 ||
      getSelectedTier == 0
    ) {
      newErrors.tier = "Please select tier";
    }

    // if (getSelectStage == 7) {
    if (Number(getStatus?.value ?? getSelectStatus ?? 0) !== 1) {
      if (
        !getSelectedCloseReason ||
        getSelectedCloseReason.length === 0 ||
        getSelectedCloseReason == 0
      ) {
        newErrors.stageClose = "Please select reason";
      }
      // if (!getRemark) {
      //         newErrors.stageCloseReason = "Please input remark";
      // }
    }
    setErrors(newErrors);

    return Object.values(newErrors).every((err) => err === "");
  };
  const handleSubmitxx = (e) => {
    alert(getSelectStage);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    // if (getSelectStage == 7) {
    if (Number(getStatus?.value ?? getSelectStatus ?? 0) !== 1) {
      if (!getSelectedCloseReason) {
        swal({
          title: "Sorry...",
          text: "กรุณาเลือก REASON.",
          icon: "warning",
        });
        return;
      }
      if (!getRemark) {
        swal({
          title: "Sorry...",
          text: "กรุณากรอก Remark.",
          icon: "warning",
        });
        return;
      }
    }

    if (!form.SMF_CUSCODE && getSelectStage == 6) {
      swal({
        title: "Sorry...",
        text: "กรุณากรอก SMF Code.",
        icon: "warning",
      });
      return;
    }
    if (selectIncoterm === "Nominate") {
      if (!getConsignee || getConsignee == 0) {
        swal({
          title: "Sorry...",
          text: "กรุณาเลือก Consignee ด้วยค่ะ",
          icon: "warning",
        });
        return;
      }
    }
    const data = {
      ...form,
      CUSTOMER_STAGE: getSelectStage,
      ACTIVE_STATUS: getStatus?.value ?? 1,
      CUSTOMER_TYPE: getSelectedType,
      CUSTOMER_TIER: getSelectedTier,
      CUSTOMER_CODE: form.CUSTOMER_CODE,
      SMF_CUSCODE: form.SMF_CUSCODE,
      CUSTOMER_NAME: form.CUSTOMER_NAME,
      TAX_ID: form.TAX_ID,
      CONTACT_NAME: form.CONTACT_NAME,
      CUSTOMER_EMAIL: form.CUSTOMER_EMAIL,
      CUSTOMER_PHONE: form.CUSTOMER_PHONE,
      CUSTOMER_ADDRESS: form.CUSTOMER_ADDRESS,
      CUSTOMER_PROVINCE: getSelectedProvince,
      CUSTOMER_WEBSITE: form.CUSTOMER_WEBSITE,
      NOTE: form.NOTE,
      DATASOURCE: form.DATASOURCE,
      NOTE: form.NOTE,
      SALES_ID: getSelectedSales,
      CREATE_BY: getCrmID,
      BU_TAG: selectedBUTag,
      DECISION_MAKER: getDecisionMaker,
      SHIPPER_CODE: getShipper,
      CNEE_CODE: getConsignee,
      AGENT_CODE: getAgent,
      SHIPPERLOAD_CODE: getShipperLoad,
      COLOAD_CODE: getCoload,
      CUSTOMER_TERM: selectIncoterm,
      CLOSE_REASON: getSelectedCloseReason,
      REMARK: getRemark,
      CAMPAIGN_ID: getSelectCampaign,
      CRM_CUSCODE: CUSTOMER_CODE,
    };
    console.log(data);
    fetch(`${api_path}/customer/customers.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status == "200") {
          swal("Done", "Save data successfully", "success").then(() => {
            //window.location = "./customers";
            window.location =
              "./customer?customer_id=" + result["message"] + "";
          });
        } else {
          swal("Sorry", result.message, "error");
        }
      });
  };
  const handleChangeName = (e) => {
    const name = e.target.value;
    setForm((prev) => ({ ...prev, CUSTOMER_NAME: name }));
    if (name.length > 3) {
      onCheckDuplicate(name);
    }
    setSelectedDecisionMaker(name);
    setDecisionMaker({
      DECISION_NAME: name,
      DECISION_NAME: name,
    });
  };
  const handleChangeTaxid = (e) => {
    const taxid = e.target.value;
    setForm((prev) => ({ ...prev, TAX_ID: taxid }));
    // ✅ กรองให้เป็นตัวเลขเท่านั้น
    // if (/^\d*$/.test(taxid)) {
    //   setForm((prev) => ({ ...prev, TAX_ID: taxid }));
    //   if (taxid.length === 13) {
    //     setError(""); // ผ่าน
    //   } else {
    //     setError("กรุณากรอกเลขผู้เสียภาษีให้ครบ 13 หลัก");
    //   }
    // }
    if (taxid.length > 3) {
      onCheckDuplicateTax(taxid);
    }
  };
  const handleChangeSmfCode = (e) => {
    const smfCode = e.target.value;
    setForm((prev) => ({ ...prev, SMF_CUSCODE: smfCode }));
    setStage({ value: 6, label: "Close-Won" });
    setSelectedStage(6);
  };
  const [selectedBUTag, setSelectedBUTag] = useState([]);
  const [getBUTagList, setBUTagList] = useState([]);
  const getBUTag = [
    { id: "AIR", name: "AIR" },
    { id: "FOOD", name: "FOOD" },
    { id: "TIRE", name: "TIRE" },
    { id: "REEFER", name: "REEFER" },
    { id: "ISOTANK", name: "ISOTANK" },
    { id: "SOC", name: "SOC" },
    { id: "WORLDWIDE", name: "WORLDWIDE" },
    { id: "SALES", name: "SALES" },
    { id: "SEA TP", name: "SEA TP" },
    { id: "SEA NON-TP", name: "SEA NON TP" },
    { id: "IMPORT", name: "IMPORT" },
    { id: "LCL", name: "LCL" },
  ];
  const handleBUTagChange = (e) => {
    setSelectedBUTag(e.value);
  };
  const [getSelectStatus, setSelectedStatus] = useState([]);
  const getStatusList = [
    { value: 0, label: "INACTIVE" },
    { value: 1, label: "ACTIVE" },
  ];
  const [getStatus, setStatus] = useState(getStatusList[1]);
  const [getIncoterm, setIncoterm] = useState([]);
  const [selectIncoterm, setSelectIncoterm] = useState();
  const optionsIncoterm = [
    { value: "Nominate", label: "Nominate" },
    { value: "Freehand", label: "Freehand" },
  ];
  const handleIncotermChange = (obj) => {
    if (obj) {
      setSelectIncoterm(obj.value);
      setIncoterm({ value: obj.value, label: obj.label });
      if (
        obj.value === "Nominate" &&
        (!getConsignee || getConsignee.length === 0)
      ) {
        swal("Warning", "กรุณาเลือก Consignee ด้วยค่ะ", "warning");
        // ถ้ามี modal หรือ focus ที่ Select consignee ได้
        // document.querySelector('.multiselect5 input')?.focus();
      }
    } else {
      setSelectIncoterm([]);
      setIncoterm([]);
    }
  };

  return (
    // <fieldset disabled={isDuplicate}>
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        {CUSTOMER_CODE ? (
          <Grid item xs={12} sm={12}>
            <StageFlow currentStage={getStage?.label} />

            {GET_HAS_SALES_VISIT && GET_HAS_SALES_VISIT == 1 ? (
              <Box display="flex" alignItems="center" gap={1}>
                {/* ไอคอน Sales Visit */}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <AccessTimeIcon style={{ color: "green" }} />
                {/* แสดงเวลาล่าสุด */}
                <Typography variant="h6">
                  Sales Visit [Last visited&nbsp;
                  {GET_LAST_SALES_VISIT
                    ? formatDateTime(GET_LAST_SALES_VISIT)
                    : "N/A"}
                  ]
                </Typography>
              </Box>
            ) : null}

            {GET_HAS_FOLLOW_UP && GET_HAS_FOLLOW_UP == 1 ? (
              <Box display="flex" alignItems="center" gap={1}>
                {/* ไอคอน Sales Visit */}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <AssignmentOutlinedIcon style={{ color: "purple" }} />
                {/* แสดงเวลาล่าสุด */}
                <Typography variant="h6">
                  Follow-up
                  {/* [Last visited
                  {GET_HAS_FOLLOW_UP
                    ? formatDateTime(GET_LAST_FOLLOW_UP)
                    : "N/A"}
                  ] */}
                </Typography>
              </Box>
            ) : null}
          </Grid>
        ) : null}
        <Grid item xs={12} sm={6}>
          <label>CRM CODE</label>
          <br />
          <TextField
            size="small"
            name="CUSTOMER_CODE"
            disabled
            variant="outlined"
            fullWidth
            value={form.CUSTOMER_CODE}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>SMF CUSCODE</label>
          <br />
          <TextField
            size="small"
            name="SMF_CUSCODE"
            variant="outlined"
            fullWidth
            value={form.SMF_CUSCODE}
            onChange={handleChangeSmfCode}
            inputProps={{ maxLength: 6 }}
            disabled={isDuplicate} // ❌ disable ถ้าเจอ
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>
            CUSTOMER NAME <span className="red">*</span>
          </label>
          <TextField
            size="small"
            name="CUSTOMER_NAME"
            variant="outlined"
            fullWidth
            required
            value={form.CUSTOMER_NAME}
            onChange={handleChangeName}
            error={isDuplicate}
            helperText={
              isDuplicate
                ? "⚠️ Customer name may already exist in the system. Please check."
                : ""
            }
            inputProps={{ maxLength: 150 }}
            // InputProps={{
            //   readOnly: CUSTOMER_CODE ? true : false, // <-- readonly ถ้ามี id
            // }}
            disabled={!!CUSTOMER_CODE && getUserRole == 1} // disable ถ้ามี id
          // disabled={
          // getUserRole == 1 ||
          // getUserRole == 2 ||
          // getUserRole == 3 ||
          // !!CUSTOMER_CODE
          //            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>
            TAX ID <span className="red">*</span>
          </label>
          <TextField
            size="small"
            name="TAX_ID"
            variant="outlined"
            fullWidth
            value={form.TAX_ID}
            onChange={handleChangeTaxid}
            inputProps={{ maxLength: 13 }}
            //inputProps={{ maxLength: 13, inputMode: "numeric" }}
            error={isDuplicateTax}
            helperText={
              isDuplicateTax
                ? "⚠️ This Tax ID may already exist in the system. Please check."
                : ""
            }
          />
          {errors.taxId && (
            <span className="error-message">{errors.taxId}</span>
          )}
        </Grid>
        <Grid item xs={12}>
          <label>ADDRESS</label>
          <TextField
            size="small"
            name="CUSTOMER_ADDRESS"
            variant="outlined"
            fullWidth
            value={form.CUSTOMER_ADDRESS}
            onChange={handleChange}
            inputProps={{ maxLength: 500 }}
            disabled={isDuplicate} // ❌ disable ถ้าเจอซ
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>PROVINCE</label>
          <Select
            className="multiselect101"
            placeholder="Select..."
            value={getProvince}
            options={provinceList}
            onChange={handleProvinceChange}
            isDisabled={isDuplicate} // ❌ disable ทั้ง dropdown
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>TEL</label>
          <TextField
            size="small"
            name="CUSTOMER_PHONE"
            variant="outlined"
            fullWidth
            value={form.CUSTOMER_PHONE}
            onChange={handleChange}
            inputProps={{ maxLength: 20 }}
            disabled={isDuplicate} // ❌ disable ถ้าเจอซ
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>EMAIL</label>
          <TextField
            size="small"
            name="CUSTOMER_EMAIL"
            variant="outlined"
            fullWidth
            value={form.CUSTOMER_EMAIL}
            onChange={handleChange}
            inputProps={{ maxLength: 100 }}
            disabled={isDuplicate} // ❌ disable ถ้าเจอซ
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>WEBSITE</label>
          <TextField
            variant="outlined"
            size="small"
            name="CUSTOMER_WEBSITE"
            fullWidth
            value={form.CUSTOMER_WEBSITE}
            onChange={handleChange}
            inputProps={{ maxLength: 100 }}
            disabled={isDuplicate} // ❌ disable ถ้าเจอซ
          />
        </Grid>
        <Grid item xs={12}>
          <label>NOTE</label>
          <TextField
            size="small"
            name="NOTE"
            fullWidth
            value={form.NOTE}
            onChange={handleChange}
            inputProps={{ maxLength: 150 }}
            disabled={isDuplicate} // ❌ disable ถ้าเจอซ
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <h4>For Sales Owner</h4>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>
            Sales <span className="red">*</span>
          </label>
          <Select
            className="multiselect100"
            options={getSalesList}
            value={getSales}
            onChange={handleSalesChange}
            getOptionLabel={(x) => x.SALE_NAME}
            getOptionValue={(x) => x.SALE_CODE}
            isDisabled={isDuplicate} // ❌ disable ทั้ง dropdown
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>
            STAGE <span className="red">*</span>
          </label>
          <Select
            className="multiselect100"
            placeholder="Select..."
            value={getStage}
            options={getStageList}
            onChange={handleStageChange}
            isDisabled={
              getUserRole == 1 ||
              getUserRole == 2 ||
              getUserRole == 3 ||
              isDuplicate
            }
          />
          {errors.stage && (
            <span className="error-message">{errors.stage}</span>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>
            CUSTOMER TIER <span className="red">*</span>
          </label>
          <Select
            className="multiselect1"
            placeholder="Select..."
            value={getTier}
            options={getTierList}
            onChange={handleTierChange}
            isDisabled={isDuplicate} // ❌ disable ทั้ง dropdown
          />
          {errors.tier && <span className="error-message">{errors.tier}</span>}
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>
            TYPE <span className="red">*</span>
          </label>
          <Select
            className="multiselect1"
            placeholder="Select..."
            value={getType}
            options={getTypeList}
            onChange={handleTypeChange}
            isDisabled={isDuplicate} // ❌ disable ทั้ง dropdown
          />
          {errors.type && <span className="error-message">{errors.type}</span>}
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>
            STATUS <span className="red">*</span>
          </label>
          <Select
            className="multiselect2"
            placeholder="Select..."
            value={getStatus}
            options={getStatusList}
            onChange={handleStatusChange}
            isDisabled={CUSTOMER_CODE ? false : true}
          />
          {errors.status && (
            <span className="error-message">{errors.status}</span>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>Campaign</label>
          <Select
            className="multiselect2"
            placeholder="Select..."
            value={getCampaign}
            options={getCampaignList}
            onChange={handleCampaignChange}
            isDisabled={
              getUserRole == 1 ||
              getUserRole == 2 ||
              getUserRole == 3 ||
              isDuplicate // 🔸เพิ่มเงื่อนไขนี้
            }
          />
        </Grid>
        {/* {getSelectStage == 7 && ( */}
        {/* {Number(getSelectStatus ?? getStatus?.value ?? 0) !== 1 && ( */}
        {getStatus?.value == 0 && (
          <>
            <Grid item xs={12} sm={6}>
              <label>
                REASON <span className="red">*</span>
              </label>
              <Select
                className="multiselect3"
                placeholder="Select..."
                value={getCloseReason}
                options={getCloseReasonList}
                onChange={handleCloseChange}
                isDisabled={isDuplicate} // ❌ disable ทั้ง dropdown
              />
              {errors.stageClose && (
                <span className="error-message">{errors.stageClose}</span>
              )}
            </Grid>
            <Grid item xs={12} sm={6}></Grid>
            <Grid item xs={12} sm={12}>
              <label>Remark</label>
              <TextField
                size="small"
                name="getRemark"
                variant="outlined"
                fullWidth
                value={getRemark}
                onChange={(e) => setRemark(e.target.value)}
                inputProps={{ maxLength: 500 }}
              />
              {errors.stageCloseReason && (
                <span className="error-message">{errors.stageCloseReason}</span>
              )}
            </Grid>
          </>
        )}
        <Grid item xs={6}>
          <label>BU</label>
          <TagBox
            dataSource={getBUTag}
            valueExpr="name"
            displayExpr="name"
            searchEnabled={true}
            onValueChanged={handleBUTagChange}
            isDisabled={isDuplicate} // ❌ disable ทั้ง dropdown
            value={selectedBUTag}
          />
        </Grid>
        <Grid item xs={12} sm={6}></Grid>
        <Grid item xs={12} sm={6}>
          <label>DECISION MAKER</label>
          <Autocomplete
            id="free-solo-demo"
            popupIcon={""}
            decisionMaker
            value={getDecisionMaker}
            options={getDecisionMakerList}
            filterOptions={filterOptions}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth />
            )}
            onChange={(event, newValue) => {
              if (newValue) {
                setDecisionMaker(newValue.value);
              } else {
                setDecisionMaker("");
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}></Grid>
        <Grid item xs={12} sm={6}>
          <label>SHIPPER</label>
          <Autocomplete
            id="free-solo-demo"
            popupIcon={""}
            shipper
            value={getShipper}
            options={getShipperList}
            filterOptions={filterOptions}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth />
            )}
            onChange={(event, newValue) => {
              if (newValue) {
                setShipper(newValue.value);
              } else {
                setShipper("");
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>CONSIGNEE</label>
          <Autocomplete
            id="free-solo-demo"
            popupIcon={""}
            consignee
            value={getConsignee}
            options={getConsigneeList}
            filterOptions={filterOptions}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth />
            )}
            onChange={(event, newValue) => {
              if (newValue) {
                setConsignee(newValue.value);
              } else {
                setConsignee("");
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>AGENT</label>
          <Autocomplete
            id="free-solo-demo"
            popupIcon={""}
            agent
            value={getAgent}
            options={getAgentList}
            filterOptions={filterOptions}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth />
            )}
            onChange={(event, newValue) => {
              if (newValue) {
                setAgent(newValue.value);
              } else {
                setAgent("");
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>ACTUAL SHIPPER/SHIPPER LOAD</label>
          <Autocomplete
            id="free-solo-demo"
            popupIcon={""}
            shipperLoad
            value={getShipperLoad}
            options={getShipperLoadList}
            filterOptions={filterOptions}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth />
            )}
            onChange={(event, newValue) => {
              if (newValue) {
                setShipperLoad(newValue.value);
              } else {
                setShipperLoad("");
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>CO LOAD</label>
          <Autocomplete
            id="free-solo-demo"
            popupIcon={""}
            coload
            value={getCoload}
            options={getColoadList}
            filterOptions={filterOptions}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth />
            )}
            onChange={(event, newValue) => {
              if (newValue) {
                setCoload(newValue.value);
              } else {
                setCoload("");
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label>INCOTERM</label>
          <Select
            className="multiselect7"
            placeholder="Select..."
            value={getIncoterm}
            options={optionsIncoterm}
            onChange={handleIncotermChange}
            isDisabled={isDuplicate} // ❌ disable ทั้ง dropdown
          />
        </Grid>
        <Grid item xs={12} sm={12} style={{ display: "flex" }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSaveDisabled}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </form>
    // </fieldset>
  );
};

export default MainContactForm;
